export default function serializeMoney(money, amount_attr = "amount", currency_attr = "amount_currency") {
  if (money !== undefined) {
    const a = {
      [amount_attr]: money ? money.value : null,
      ...(currency_attr ? { [currency_attr]: money ? money.currency : null } : {}),
    };
    return a;
  }
}



// WEBPACK FOOTER //
// ./src/lib/utils/api/serializers/serializeMoney.js